export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_HOMEPAGE = process.env.REACT_APP_HOMEPAGE;
//NODE_ENV === 'development' ? "http://localhost/Students_Affairs/backend/" : 'https://sis.ivyis.org/backend/';